import { forwardRef } from "react";
import { prependZero } from "./operatingHoursUtils";
import classes from "./TimeInput.module.scss";
import { TextInput } from "@vfuk/core-text-input/dist/TextInput";
import { TimeInputState } from "./types";

export type TimeInputFormat = {
  hours: string;
  minutes: string;
  seconds?: string;
  milliseconds?: string;
};

type TimeInputProps = {
  onChange: (value: TimeInputFormat) => void;
  onBlur?: () => void;
  value: TimeInputFormat;
  name: string;
  error?: boolean;
  state?: TimeInputState;
};

const TimeInput = forwardRef<TextInput, TimeInputProps>(
  (props: TimeInputProps, ref): JSX.Element => {
    const onHourBlur = () => {
      const hoursInt = parseInt(props.value.hours);
      if (hoursInt > 12 && hoursInt < 24) {
        props.onChange({
          hours: prependZero(hoursInt.toString()),
          minutes: props.value.minutes,
        });
      } else {
        props.onChange({
          hours: prependZero(props.value.hours),
          minutes: props.value.minutes,
        });
      }
    };

    const onMinutesBlur = () => {
      props.onChange({
        hours: props.value.hours,
        minutes: prependZero(props.value.minutes),
      });
    };

    let timeoutId: ReturnType<typeof setTimeout>;
    const onFieldsetBlur = () => {
      timeoutId = setTimeout(() => {
        props.onBlur?.();
      }, 5);
    };

    const onFieldsetFocus = () => {
      clearTimeout(timeoutId);
    };

    return (
      <fieldset
        className={classes.TimeInputContainer}
        onFocus={onFieldsetFocus}
        onBlur={onFieldsetBlur}
      >
        <TextInput
          ref={ref}
          id={`${props.name}-hour`}
          name={`${props.name}-hour`}
          dataAttributes={{ "aria-label": `${props.name} hour` }}
          type="number"
          maxLength={2}
          value={props.value.hours}
          state={props.error ? "error" : props.state}
          onChange={(event) => {
            const hours = Number(event.target.value);
            hours >= 0 &&
              hours < 25 &&
              props.onChange({
                hours: hours.toString(),
                minutes: props.value.minutes,
              });
          }}
          onBlur={onHourBlur}
        />
        <span>:</span>
        <TextInput
          id={`${props.name}-minute`}
          name={`${props.name}-minute`}
          dataAttributes={{ "aria-label": `${props.name} minute` }}
          type="number"
          maxLength={2}
          value={props.value.minutes}
          state={props.error ? "error" : props.state}
          onChange={(event) => {
            const minutes = Number(event.target.value);
            minutes >= 0 &&
              minutes < 60 &&
              props.onChange({
                hours: props.value.hours,
                minutes: minutes.toString(),
              });
          }}
          onBlur={onMinutesBlur}
        />
      </fieldset>
    );
  }
);

TimeInput.displayName = "TimeInput";

export default TimeInput;
